import { useEffect } from 'react';

import { get } from 'lodash';
import { useFormContext, useFormState, useWatch } from 'react-hook-form';

import { Flex, Input } from '@ui';

export interface ErrorFieldProps {
  name: string;
  watchFields?: string[];
}

export const ErrorField: React.FC<ErrorFieldProps> = ({ name, watchFields }) => {
  const { trigger } = useFormContext();

  // Watch specific fields to trigger re-renders when they change
  // Always call hook - pass empty array if no fields to watch
  const watchedValues = useWatch({ name: watchFields || [] });

  // Trigger validation when watched fields change
  useEffect(() => {
    if (watchFields && watchFields.length > 0) {
      trigger(watchFields);
    }
  }, [watchedValues, watchFields, trigger]);

  // Use useFormState to get the current error state
  const { errors } = useFormState();

  const error = get(errors, name);
  if (!error) return null;

  const errorMessage =
    typeof error === 'object' && 'message' in error ? error.message : error;

  return (
    <Flex direction={'column'} justify="flex-end">
      <Input.Error size="xl">{errorMessage?.toString()}</Input.Error>
    </Flex>
  );
};
